// This object defines the different types of user action events that can occur in the application.
// Each property represents a specific type of user action event, and its value is a string
// that serves as a unique identifier for that event type.
export const UserActionsEventTypes = {
  VIEW_CHANGE: 'all_apps_view_type_change',
  CATEGORY_TYPE_CHANGE: 'all_apps_category_type_change',

  TOP_NAV_CATEGORY_CHANGE: 'top_nav_category_change',
  TOP_NAV_SUB_CATEGORY_CHANGE: 'top_nav_sub_category_change',
  TOP_NAV_VIEW_ALL_APPS_CLICKED: 'top_nav_view_all_apps_clicked',
  TOP_NAV_FAVORITE_APP: 'top_nav_favorite_app',
  TOP_NAV_UNFAVORITE_APP: 'top_nav_unfavorite_app',

  HOME_PAGE_SIDE_NAV_CLICK: 'home_page_side_nav_click',

  ANNOUNCEMENTS_FILTER_BY_APP: 'announcements_filter_by_app',
  ANNOUNCEMENTS_FILTER_BY_CATEGORY: 'announcements_filter_by_category',

  TUTORIALS_FILTER_BY_APP: 'tutorials_filter_by_app',
  TUTORIALS_FILTER_BY_CATEGORY: 'tutorials_filter_by_category',
  TUTORIALS_VIDEO_CLICKED: 'tutorials_video_clicked',

  APP_SPECIFIC_HELP_PANEL_CHANGE: 'app_specific_help_panel_change',
  APP_SPECIFIC_BOARD_RESIZE: 'app_specific_board_resize',

  WELCOME_WIDGET_LINK_CLICKED: 'welcome_widget_link_clicked',

  ANNOUNCEMENT_WIDGET_OPEN: 'announcement_widget_open',
  ANNOUNCEMENT_WIDGET_LINK_CLICKED: 'announcement_widget_link_clicked'
};
export const Titles = {
  TITLE_TICKETS: 'Ticket Health',
  TITLE_USER_METRICS: 'User Metrics',
  TITLE_SAS: 'Security Risks',
  TITLE_BUSINESS_REPORTING: 'OE Insights',
  TITLE_OP_EX: 'Operational Excellence',
  TITLE_POLICY_ENGINE: 'Policy Engine',
  TITLE_DOGMA: 'Pipeline Health',
  TITLE_RISK_REMEDIATOR: 'Risk Remediator',
  TITLE_COST_METRICS: 'Cost Metrics',
  TITLE_OP_MAPPING: 'Data Mapping',
  TITLE_OP_KPI_METRICS: 'KPI Metrics',
  TITLE_CRADLE: 'Cradle',
  TITLE_AI_SUMMARY: 'AI Insights',
  TITLE_ALL_APPS: 'View All Apps',
  TITLES_ANNOUNCEMENTS: 'Product Launches'
};

export const KingPinSideNavLinks = {
  DAS_FGBS_GOALS: 'https://kingpin.amazon.com/#/businessReview/reports/ca69b0ae-71ab-436c-82b9-838f552d6025',
  DAS_FINANCE_VP_GOALS: 'https://kingpin.amazon.com/#/businessReview/reports/8eb88af9-6bd6-451f-8481-01c082d2901d',
  DAS_FINTECH_TEAM_GOALS: 'https://kingpin.amazon.com/#/businessReview/reports/d491fc94-2df3-4245-bbfb-b64271290320'
};
